<template>
  <div class="content">
    <div class="md-layout md-alignment-center">
      <div
        class="md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <enquiry-form data-background-color="secondary" />
      </div>
    </div>
  </div>
</template>

<script>
import EnquiryForm from "./Forms/EnquiryForm.vue";
export default {
  components: {
    EnquiryForm
  }
};
</script>
